import { v4 as uuidv4 } from 'uuid';
export class EngagementActivityActionModel {
    constructor() {
        this.id = uuidv4();
        this.activityId = null;
        this.action = '';
        this.isDone = false;
    }
}
export default class EngagementActivityAction extends EngagementActivityActionModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
